import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

export interface CustomButtonProps {
  icon: React.ElementType;
  text: string;
  [key: string]: any;
}

export const CustomButton: React.FC<CustomButtonProps> = ({
  icon: Icon,
  text,
  ...props
}) => (
  <Tooltip title={text}>
    <IconButton {...props} size="large" color="inherit">
      <Icon color="inherit" />
    </IconButton>
  </Tooltip>
);
